//  Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { IApproverResponseResult, SecurityApprovalMethod } from '../../../../types/security-requests';
import AuthHelper from '../../../auth/authHelper';
import {FormControl} from '@angular/forms';

export interface ISecurityRequestDialogConfig {
  results: IApproverResponseResult[];
  minimumApprovalPercentRequired: number;
  requestTitle: string;
  subTitle?: string;
  securityApprovalMethod: number;
}

export interface ISecurityRequestDialogResult {
  notifyApprovers: boolean;
}

@Component({
    selector: 'app-security-request-dialog',
    templateUrl: './security-request-dialog.component.html',
    styleUrls: ['./security-request-dialog.component.scss'],
    standalone: false
})
export class SecurityRequestDialogComponent implements OnInit {

  readonly userId = AuthHelper.getUidFromToken();

  public readonly notifyApprovers = new FormControl(true);
  securityApprovalMethodType = SecurityApprovalMethod;

  constructor(private readonly dialogRef: MatDialogRef<ISecurityRequestDialogConfig>,
              @Inject(MAT_DIALOG_DATA) public data: ISecurityRequestDialogConfig) { }

  ngOnInit(): void {
  }

  onSendRequest() {
    const result: ISecurityRequestDialogResult = {
      notifyApprovers: this.notifyApprovers.value
    };
    this.dialogRef.close(result);
  }

  close() {
    this.dialogRef.close();
  }

}
